var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlayerPrev = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "currentcolor",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M21.5 1.385 11 10.863a1.54 1.54 0 0 0 0 2.273l10.5 9.479a1.5 1.5 0 0 0 2.5-1.136V2.521a1.5 1.5 0 0 0-2.5-1.136M0 0h7v24H0z"
})));
export default SvgPlayerPrev;